/* esm.sh - applesauce-core@5.2.0/dist/helpers/json */
export * from "/*applesauce-core@5.2.0/esnext/dist/helpers/json.mjs";
